<template>
  <!-- <div> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

  <!-- <v-container fluid id="outer-container">
    <v-layout row wrap id="wrap-container"> -->
  <div style="background-color: #ffffff;" id="home-container">
    <section>
      <!-- <v-carousel :cycle="false" style="height: 590px;"> -->
      <v-carousel style="height: 590px;" :interval="speed" :cycle="false" class="test-class">
        <v-carousel-item
          v-for="(image,i) in images"
          :key="i"
          :src="image"
          class="item-class"
        >
          <template v-if="i === 0">
            <v-layout justify-center v-if="!mobile">
              <v-flex xs12>
                <v-img
                :src="lmsIcon"
                contain
                height=128
                class="gameImg"
                ></v-img>
                <h1 class="lms-header-title">Lobstermania Slots<sup>&trade;</sup></h1>
                <p class="lms-header-body">
                  Spin the reels to play "Lobstermania", "Stinkin' Rich Hot Poker Dice"<br>
                  &amp; all your favorite REAL VEGAS slot games; each packed with unique<br>
                  features, HUGE PAYOUTS &amp; fun gameplay!
                </p>
              </v-flex>
            </v-layout>

            <v-layout justify-center v-else>
              <v-flex xs10>
                <v-img
                  :src="lmsIcon"
                  contain
                  height=95
                ></v-img>
                <h1 class="lms-mobile-header-title text-to-crop">Lobstermania Slots<sup>&trade;</sup></h1>
                <p class="lms-mobile-header-body">
                  Spin the reels to play "Lobstermania", "Stinkin' Rich Hot Poker Dice"<br>
                  &amp; all your favorite REAL VEGAS slot games; each packed with unique<br>
                  features, HUGE PAYOUTS &amp; fun gameplay!
                </p>
              </v-flex>
            </v-layout>

            <v-layout row class="play-buttons">
              <v-flex xs12>
                <v-layout row justify-center :class="{ buttonMargin: mobile }">
                  <!-- <v-flex xs1 offset-xs4></v-flex> -->
                  <v-flex xs6 sm4 md2 lg2 xl1>
                      <a class="storeLinks" href="https://lobstermania-slots.onelink.me/PRsr?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtolmsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtolmsapp&af_dp=com.ksgmobileinc.lobstermaniaslots" style="display:inline-block;" target="_blank" id="facebookBtn"><img :src="smvIos" style="width: 90%; height: 90%; min-width: 12rem;" id="smvIos" @mouseover="changeImage('smvIos')" @mouseleave="defaultImage('smvIos')"></a>
                  </v-flex>

                  <v-flex xs6 sm4 md2 lg2 xl1>
                      <a class="storeLinks" href="https://lobstermania-slots.onelink.me/PRsr?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtolmsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtolmsapp&af_dp=com.ksgmobileinc.lobstermaniaslots" style="display:inline-block;" target="_blank" id="facebookBtn"><img :src="smvGoogle" style="width: 90%; height: 90%; min-width: 12rem;" id="smvGoogle" @mouseover="changeImage('smvGoogle')" @mouseleave="defaultImage('smvGoogle')"></a>
                  </v-flex>
                </v-layout>

                <v-layout row justify-center v-if="!mobile">
                  <!-- <v-flex xs4 offset-xs4> -->
                  <!-- <v-flex xs8 sm4 md3 lg2 xl2 justify-center style="display: flex; margin-top: -2rem;">
                    <a href="https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&pid=KSGWebSite&c=website_connect&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F" target="_blank">
                      <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 25rem;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                    </a>
                  </v-flex> -->
                </v-layout>
                <v-layout row justify-center v-else>
                  <v-flex xs8 sm4 md3 lg2 xl2>
                    <!-- <v-img
                      :src="smvButton"
                      @click="smvClick"
                      min-height="100"
                      min-width="200"
                      max-height="135"
                      contain
                      id="smvBtn"
                      style="margin-top: -1.75rem;"
                    ></v-img> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </template>

          <template v-if="i === 1">
            <v-layout justify-center v-if="!mobile">
              <v-flex xs12>
                <v-img
                :src="smvIcon"
                contain
                height=128
                class="gameImg"
                ></v-img>
                <h1 class="header-title">Show Me Vegas Slots<sup>&trade;</sup></h1>
                <!-- <h1 class="header-title">Show Me Vegas Slots&trade;</h1> -->
                <p class="header-body">
                  Bring Las Vegas Home! Spin the reels and enjoy real Vegas casino slots<br>
                  like "Ghost Island", "Fishing Bob", "Super Sally's Shrimpmania"; all packed<br>
                  with unique features, HUGE PAYOUTS &amp; fun gameplay!<br>
                  Now available on mobile devices and desktop.
                </p>
              </v-flex>
            </v-layout>

            <v-layout justify-center v-else>
              <v-flex xs10>
                <v-img
                  :src="smvIcon"
                  contain
                  height=95
                ></v-img>
                <h1 class="mobile-header-title text-to-crop">Show Me Vegas Slots<sup>&trade;</sup></h1>
                <p class="mobile-header-body">
                  Bring Las Vegas Home! Spin the reels and enjoy real Vegas casino slots
                  like "Ghost Island", "Fishing Bob", "Super Sally's Shrimpmania"; all packed
                  with unique features, HUGE PAYOUTS &amp; fun gameplay!
                  Now available on mobile devices and desktop.
                </p>
              </v-flex>
            </v-layout>

            <v-layout row class="play-buttons">
              <v-flex xs12>
                <v-layout row justify-center :class="{ buttonMargin: mobile }">
                  <!-- <v-flex xs1 offset-xs4></v-flex> -->
                  <v-flex xs6 sm4 md2 lg2 xl1>
                      <!-- <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_iOSAppStore" style="display:inline-block; width: 100%; height: 100%; min-width: 12rem;" @mouseenter="changeButton('ios-smvHover')" @mouseleave="defaultButton('ios-smvButton')" target="_blank" id="iosBtn"><v-img :src="smvIos" contain ></v-img></a> -->
                      <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_iOSAppStore" style="display:inline-block;" target="_blank" id="facebookBtn"><img :src="smvIos" style="width: 90%; height: 90%; min-width: 12rem;" id="smvIos" @mouseover="changeImage('smvIos')" @mouseleave="defaultImage('smvIos')"></a>
                  </v-flex>

                  <v-flex xs6 sm4 md2 lg2 xl1>
                      <!-- <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_GooglePlayStore" style="display:inline-block; width: 100%; height: 100%; min-width: 12rem;" @mouseenter="changeButton('google-smvHover')" @mouseleave="defaultButton('google-smvButton')" target="_blank" id="googleBtn"><v-img :src="smvGoogle" contain ></v-img></a> -->
                      <a class="storeLinks" href="http://link.showmevegasslots.com/ShowMeVegasSlots_GooglePlayStore" style="display:inline-block;" target="_blank" id="facebookBtn"><img :src="smvGoogle" style="width: 90%; height: 90%; min-width: 12rem;" id="smvGoogle" @mouseover="changeImage('smvGoogle')" @mouseleave="defaultImage('smvGoogle')"></a>
                  </v-flex>

                  <v-flex xs1 sm4 md2 lg2 xl1 v-if="!mobile && !ipad">
                    <a class="storeLinks" href="https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&pid=KSGWebSite&c=website_connect&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F" style="display:inline-block;" target="_blank" id="facebookBtn"><img :src="smvFacebook" style="width: 90%; height: 90%; min-width: 12rem;" id="smvFacebook" @mouseover="changeImage('smvFacebook')" @mouseleave="defaultImage('smvFacebook')"></a>
                  </v-flex>
                </v-layout>

                <v-layout row justify-center v-if="!mobile">
                  <!-- <v-flex xs4 offset-xs4> -->
                  <v-flex xs8 sm4 md3 lg2 xl2 justify-center style="display: flex; margin-top: -2rem;">
                    <!-- <v-img
                      :src="smvButton"
                      @click="smvClick"
                      min-height="100"
                      min-width="200"
                      max-height="135"
                      contain
                      id="smvBtn"
                      @mouseenter="changeButton"
                      @mouseleave="defaultButton"
                      style="margin-top: -1rem;"
                    ></v-img> -->
                    <!-- <a href="https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&pid=KSGWebSite&c=website_connect&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F" target="_blank">
                      <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 25rem;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                    </a> -->
                    <a href="https://showmevegasslots.onelink.me/uBTP?utm_source=ksg_web&utm_medium=website_click&utm_campaign=ksg_webtosmvsapp&utm_content=playforfreebutton&utm_term=all_users&pid=ksg_web&c=ksg_webtosmvsapp&af_dp=com.ksgmobileinc.showmevegasslotsv2" target="_blank">
                      <img :src="smvButton" id="pcBtn" alt="Show Me Vegas Play Button" style="width: 25rem;" @mouseover="changeButton('pc-smvHover')" @mouseleave="defaultButton('pc-smvButton')" />
                    </a>
                    <!-- <v-btn large href="https://dingslotsding.onelink.me/EsB9?promoLink=3s9BpWKFc2UIIQaN&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F" target="_blank" class="header-btn playNowLink">
                    </v-btn> -->
                  </v-flex>
                </v-layout>
                <v-layout row justify-center v-else>
                  <v-flex xs8 sm4 md3 lg2 xl2>
                    <v-img
                      :src="smvButton"
                      @click="smvClick"
                      min-height="100"
                      min-width="200"
                      max-height="135"
                      contain
                      id="smvBtn"
                      style="margin-top: -1.75rem;"
                    ></v-img>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </template>
        </v-carousel-item>
      </v-carousel>
    </section>

    <section id="descriptionBackground">
        <v-layout
          column
          wrap
          class="py-5"
          align-center
          xs10 offset-xs1
        >
          <v-flex xs12>
            <v-container grid-list-xs id="descriptionContainer">
              <v-layout row wrap align-center justify-center>
                <v-flex xs12 md10 class="ieFlex">
                  <v-card class="elevation-0 transparent">
                    <!-- <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">flash_on</v-icon>
                    </v-card-text> -->
                    <img
                      :src="socialCasino"
                      style="border-radius: 1rem; width: 70%;">
                    <v-card-title primary-title class="layout justify-center pb-1">
                      <div class="headline body-title"><span class="home-description-title">Social Casino</span></div>
                    </v-card-title>
                    <v-card-text class='description-body pt-1' id="social-casino-text">
                      Big wins, and bigger fun on<br>
                      your desktop or mobile device!
                    </v-card-text>
                    <!-- <v-btn large color="#f38120" class="body-btn"><span class="header-btn-text">PLAY NOW</span></v-btn> -->
                    <v-btn round color="#fd00b5" class="home-body-btn playNowLink" style="width: 70%" to="/social-games"><span class="home-body-btn-text">LEARN MORE</span></v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  data () {
    return {
      video: 'WWoQVBokMAA',
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      images: [
        require('../assets/carousel/Carousel_Header_LMS.png'),
        require('../assets/carousel/Carousel_Header1.png')
        // require('../assets/carousel/Carousel_Header2.png'),
        // require('../assets/carousel/Carousel_Header3.png'),
        // require('../assets/carousel/Carousel_Header4.png')
        // { src: require('../assets/carousel/9_FishingBob.jpg') },
        // { src: require('../assets/carousel/2_BlackStallion.jpg') },
        // { src: require('../assets/carousel/6_SnowDay.jpg') },
        // { src: require('../assets/carousel/5_Lobstermania2.jpg') },
        // { src: require('../assets/carousel/7_JadeFortune.jpg') },
        // { src: require('../assets/carousel/4_HotRoll.jpg') },
        // { src: require('../assets/carousel/8_FirePearl.jpg') }
      ],
      iconImage: require('../assets/Icon_DingSlotsDing.png'),
      smvIcon: require('../assets/ShowMeVegasSlotsLogo.png'),
      lmsIcon: require('../assets/LobsterManiaSlotsLogo.png'),
      googlePlay: require('../assets/buttons/Button_GooglePlayEnabled.png'),
      iosStore: require('../assets/buttons/Button_AppStoreEnabled.png'),
      smvGoogle: require('../assets/buttons/Button_GooglePlayEnabled-smv.png'),
      smvGoogleHover: require('../assets/buttons/Button_GooglePlayOver-smv.png'),
      smvIos: require('../assets/buttons/Button_AppStoreEnabled-smv.png'),
      smvIosHover: require('../assets/buttons/Button_AppStoreOver-smv.png'),
      smvFacebook: require('../assets/buttons/Button_FindUsEnabled.png'),
      smvFacebookHover: require('../assets/buttons/Button_FindUsOver.png'),
      smvButton: require('../assets/buttons/Button_PlayForFreeEnabled.png'),
      smvHover: require('../assets/buttons/Button_PlayForFreeOver.png'),
      landBased: require('../assets/thumbnails/Thumbnail_LandBased.png'),
      socialCasino: require('../assets/thumbnails/Thumbnail_SocialCasinos.png'),
      // lobster: require('../assets/thumbnails/Thumbnail_Lobstermania.png'),
      // ding: require('../assets/thumbnails/Thumbnail_DingSlotsDing.png'),
      // smvThumbnail: require('../assets/thumbnails/Thumbnail_SMVS.png'),
      windowWidth: 0,
      windowHeight: 0,
      speed: 10000,
      footerHeight: 0,
      originalFooter: 0
    }
  },
  computed: {
    computedWidth () {
      // switch (this.$vuetify.breakpoint.name) {
      //   case 'xs': return '220px'
      //   case 'sm': return '400px'
      //   case 'md': return '500px'
      //   case 'lg': return '600px'
      //   case 'xl': return '800px'
      // }
      return this.screenWidth
    },
    mobile () {
      // return navigator.userAgent.toLowerCase().indexOf('mobile') > -1
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    ipad () {
      return navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    }
  },
  methods: {
    // test (i) {
    //   console.log(i)
    // },
    changeImage (icon) {
      let el = document.querySelector(`#${icon}`)
      let hoverImage = icon + 'Hover'
      el.src = this[hoverImage]
      el.srcset = this[hoverImage]
    },
    defaultImage (icon) {
      let el = document.querySelector(`#${icon}`)
      el.src = this[icon]
      el.srcset = this[icon]
    },
    smvClick () {
      window.open('https://showmevegasslots.onelink.me/uBTP?promoLink=UmMlkY2Q4dYjMkW7&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.showmevegasslotsv2%3A%2F%2F', '_blank')
    },
    changeButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector('#smvBtn')
      // el.src = this.smvHover
      // el.srcset = this.smvHover

      // let el = document.querySelector('#smvBtn div.v-image__image--contain')
      // el.style.backgroundImage = 'url(' + this.smvHover + ')'
    },
    defaultButton (term) {
      let termArr = term.split('-')
      let platform = termArr[0]
      let el = document.querySelector(`#${platform}Btn`)
      let image = this[termArr[1]]
      el.src = image
      el.srcset = image
      // let el = document.querySelector('#smvBtn')
      // el.src = this.smvButton
      // el.srcset = this.smvButton
      // let el = document.querySelector(`#smvBtn div.v-image__image--contain`)
      // el.style.backgroundImage = 'url(' + this.smvButton + ')'
    },
    getWindowWidth (event) {
      // this.windowWidth = document.documentElement.clientWidth
      this.windowWidth = window.innerWidth
      // console.log(window.innerWidth)

      if (this.windowWidth > 1850) {
        document.querySelector('#iosBtn').style.marginLeft = '0'
        document.querySelector('#dsdiosBtn').style.marginLeft = '0'
        document.querySelector('.gameImg').style.marginTop = '1rem'
      } else if (this.windowWidth > 1350 && this.windowWidth <= 1850) {
        document.querySelector('#iosBtn').style.marginLeft = '-3rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-3rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 1050 && this.windowWidth <= 1350) {
        document.querySelector('#iosBtn').style.marginLeft = '-5rem'
        document.querySelector('#dsdBtn').style.marginLeft = '-5rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 700 && this.windowWidth <= 1050) {
        document.querySelector('#iosBtn').style.marginLeft = '-7rem'
        document.querySelector('#dsdBtn').style.marginLeft = '-7rem'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 600 && this.windowWidth <= 700) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-7rem'
        document.querySelector('.header-title').style.fontSize = '62px'
        document.querySelector('.header-body').style.fontSize = '20px'

        document.querySelector('.header-two').style.fontSize = '62px'
        document.querySelector('.body-two').style.fontSize = '20px'

        document.querySelector('.header-three').style.fontSize = '62px'
        document.querySelector('.body-three').style.fontSize = '20px'
        document.querySelector('.gameImg').style.marginTop = '2rem'
      } else if (this.windowWidth > 470 && this.windowWidth <= 600) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '50px'
        document.querySelector('.header-body').style.fontSize = '16px'

        document.querySelector('.header-two').style.fontSize = '50px'
        document.querySelector('.body-two').style.fontSize = '16px'

        document.querySelector('.header-three').style.fontSize = '50px'
        document.querySelector('.body-three').style.fontSize = '16px'
        document.querySelector('.gameImg').style.marginTop = '3rem'
      } else if (this.windowWidth > 400 && this.windowWidth <= 450) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '45px'
        document.querySelector('.header-body').style.fontSize = '14px'

        document.querySelector('.header-two').style.fontSize = '45px'
        document.querySelector('.body-two').style.fontSize = '14px'

        document.querySelector('.header-three').style.fontSize = '45px'
        document.querySelector('.body-three').style.fontSize = '14px'
        // document.querySelector('.gameImg').style.marginTop = '3.5rem'
      } else if (this.windowWidth <= 400) {
        document.querySelector('#iosBtn').style.marginLeft = '-9rem'
        document.querySelector('#dsdiosBtn').style.marginLeft = '-9rem'
        document.querySelector('.header-title').style.fontSize = '40px'
        document.querySelector('.header-body').style.fontSize = '15px'

        document.querySelector('.header-two').style.fontSize = '40px'
        document.querySelector('.body-two').style.fontSize = '13px'

        document.querySelector('.header-three').style.fontSize = '40px'
        document.querySelector('.body-three').style.fontSize = '13px'
        // document.querySelector('.gameImg').style.marginTop = '3.5rem'
      }
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    changeSocialHeight (event) {
      // if (this.windowWidth >= 960) {
      //   let slotHeight = document.querySelector('#slot-games-text').clientHeight
      //   document.querySelector('#social-casino-text').style.height = slotHeight.toString() + 'px'
      // } else if (this.windowWidth >= 738 && this.windowWidth < 960) {
      //   document.querySelector('#social-casino-text').style.height = '52px'
      // } else if (this.windowWidth > 408 && this.windowWidth <= 737) {
      //   document.querySelector('#social-casino-text').style.height = '88px'
      // } else if (this.windowWidth > 350 && this.windowWidth <= 408) {
      //   console.log(this.windowWidth)
      //   document.querySelector('#social-casino-text').style.height = '124px'
      // } else if (this.windowWidth >= 0 && this.windowWidth <= 350) {
      //   document.querySelector('#social-casino-text').style.height = '160px'
      // }
      if (this.windowWidth >= 1264) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 960 && this.windowWidth < 1264) {
        document.querySelector('#slot-games-text').style.height = '160px'
      } else if (this.windowWidth >= 714 && this.windowWidth < 960) {
        document.querySelector('#slot-games-text').style.height = '52px'
      } else if (this.windowWidth >= 422 && this.windowWidth < 714) {
        document.querySelector('#slot-games-text').style.height = '88px'
      } else if (this.windowWidth >= 0 && this.windowWidth < 422) {
        document.querySelector('#slot-games-text').style.height = '124px'
      }
    }
  },
  mounted () {
    // commented all these below as I changed to align-center from align-start for v-layout for cards
    this.$nextTick(function () {
      // window.addEventListener('resize', this.getWindowWidth)
      // window.addEventListener('resize', this.getWindowHeight)
      // window.addEventListener('resize', this.changeSocialHeight)

      // Init
      // this.getWindowWidth()
      // this.getWindowHeight()
      // this.changeSocialHeight()
    })

    document.querySelector('.v-window__container').style.height = '100%'
    document.querySelector('.v-carousel__item').style.height = '100%'
    document.querySelector('.v-carousel__controls').style.background = 'rgba(0,0,0,0)'
    // document.querySelectorAll('.v-carousel__controls__item').forEach(function (el) {
    //   console.log(el)
    //   el.style.marginLeft = '0px !important'
    //   el.style.marginRight = '0px !important'
    // })

    // if (this.mobile) {
    //   Array.from(document.querySelectorAll('.playNowLink')).forEach(function (el) {
    //     el.href = 'https://dingslotsding.onelink.me/EsB9?promoLink=hiwr7xiuolZN3wYK&utm_source=KSGWebSite&utm_medium=ksg_website_mobile&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F'
    //   })
    // } else {
    //   Array.from(document.querySelectorAll('.storeLinks')).forEach(function (el) {
    //     el.href = 'https://dingslotsding.onelink.me/EsB9?promoLink=3s9BpWKFc2UIIQaN&utm_source=KSGWebSite&utm_medium=ksg_website_web&utm_campaign=Persistent%2Cwebsite_connect%2CNULL%2CNULL&utm_content=NULLApp_Button&utm_term=G1%2CV0%2CNULL%2CR0%2C&af_dp=com.ksgmobileinc.dingslotsding%3A%2F%2F'
    //   })
    // }

    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      Array.from(document.querySelectorAll('.ieFlex')).forEach(function (el) {
        let docFrag = document.createDocumentFragment()
        while (el.firstChild) {
          let child = el.removeChild(el.firstChild)
          docFrag.appendChild(child)
        }

        // replace el with document fragment
        el.parentNode.replaceChild(docFrag, el)
      })

      this.footerHeight = parseInt(getComputedStyle(document.querySelector('#descriptionContainer')).height) + 30

      this.originalFooter = parseInt(getComputedStyle(document.querySelector('#footer')).height)
      document.querySelector('#footer').style.height = this.footerHeight + 'px'
    }

    // resizing UI; commented out for now to push 2 new jobs
    // window.onresize = function () {
    //   console.log(`Width: ${window.innerWidth}`)
    //   console.log(`Height: ${window.innerHI}`)
    //   console.log('===')
    // }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('resize', this.changeSocialHeight)

    document.querySelector('#footer').style.height = this.originalFooter + 'px'
  }
}
</script>

<style lang="scss" scoped>
#outer-container {
  display: grid;
  justify-content: center;
}

#wrap-container {
  color: white;
  text-align: left;
  width: 70vw;
}

.gameImg {
  margin-top: 1.5rem;
}

.header-btn {
  border-radius: 2rem;
  position: relative;
}

.header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #ffffff;
  font-size: 3.8rem;
}

.lms-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #1d3464;
  font-size: 3.8rem;
}

.mobile-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  font-size: 2.8rem;
}

.lms-mobile-header-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 800;
  color: #1d3464;
  line-height: 1;
  font-size: 2.8rem;
}

.header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.3;
}

.lms-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #001740;
  font-size: 20px;
  line-height: 1.3;
}

.mobile-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 500;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.2;
}

.lms-mobile-header-body {
  font-family: lato, sans-serif;
  font-style: normal;
  font-weight: 600;
  color: #001740;
  font-size: 20px;
  line-height: 1.2;
}

.mobileHeader {
  margin-top: 5rem;
}

.header-btn-text {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  color: #ffffff;
  font-size: 27px;
}

.buttonMargin {
  margin-top: -1.75rem;
}

.swiper-slide {
  display: flex;
  justify-content: center;
}

#descriptionBackground {
  background-image: url('../assets/Background_Yellow.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.home-description-title {
  font-family: 'open-sans-bold', serif;
  // font-style: normal;
  // font-weight: 800;
  font-size: 2rem;
  color: #ff9005;
}

.description-body {
  font-family: 'open-sans-semibold', serif;
  font-size: 1.4rem;
  color: #120035;
}

.header-btn-flex {
  display: grid;
  align-self: center;
}

.headline-title {
  font-family: museo-slab, serif !important;
  font-style: normal;
  font-weight: 700;
  font-size: 30px !important;
  color: #335091;
  letter-spacing: -1px !important;
}

.body-title {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 33px;
  color: #f6821f;
}

.home-body-btn {
  font-family: 'open-sans-extrabold', serif;
  font-size: 1.4rem;
}

.home-body-btn-text {
  color: #ffffff;
}

.item-class, .v-carousel__item {
  height: 100%;
}

@media only screen and (min-width: 2000px) {
  #smvButton {
    margin-top: -1rem;
  }
}

@media only screen and (min-width: 2150px) {
  #smvButton {
    margin-top: -2rem;
  }
}

@mixin lhCrop($line-height) {
  &::before {
    content: '';
    display: block;
    height: 0;
    width: 0;
    margin-top: calc((1 - #{$line-height}) * 0.5em);
  }
}

.text-to-crop {
  @include lhCrop(1.25); //line-height: 1.2
}

sup {
  vertical-align: sub;
}
</style>
